import { OnInit } from '@angular/core';
import { OptimizerServiceService } from '../optimizer-service.service';
import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Options } from 'ng5-slider';
import {SlimLoadingBarService} from '@cime/ngx-slim-loading-bar';
import { ToastrService } from 'ngx-toastr';
// import { $ } from 'protractor';
import { PageScrollService } from 'ngx-page-scroll-core';
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { isObject } from 'util';
import * as $ from 'jquery';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';

@Component({
  selector: 'app-optimizer',
  templateUrl: './optimizer.component.html',
  styleUrls: ['./optimizer.component.css']
})
export class OptimizerComponent implements OnInit {


  // Statistic Data For Have
  _id: string;
  rate_of_return: any;
  standard_deviation: any;
  variance_drag_phantom_tax: any;
  sharpe_ratio: any;
  probability_of_any_loss: any;
  amount_of_money_at_risk: any;
  upper_return: any;
  lower_return: any;
  beta:any;
  upside_capture_ratio:any;
  downside_capture_ratio:any;

  // Statistic Data for Need
  need_id: string;
  need_rate_of_return: any;
  need_standard_deviation: any;
  need_variance_drag_phantom_tax: any;
  need_sharpe_ratio: any;
  need_probability_of_any_loss: any;
  need_amount_of_money_at_risk: any;
  need_upper_return: any;
  need_lower_return: any;
  need_beta:any;
  need_upside_capture_ratio:any;
  need_downside_capture_ratio:any;
  need_amount_of_income:any;
  need_income_percentage:any;

  //Proposed Solutions
  solution_rate_of_return: any;
  solution_standard_deviationsss: any;
  solution_variance_drag_phantom_tax: any;
  solution_sharpe_ratio: any;
  solution_probability_of_any_loss: any;
  solution_amount_of_money_at_risk: any;
  solution_upper_return: any;
  solution_lower_return: any;
  solution_beta:any
  solution_upside_capture_ratio:any;
  solution_downside_capture_ratio:any;
  solution_ulcer_index:any;
  solution_amount_of_income:any;
  solution_income_percentage:any;


  title = 'Chaptimizer';
 //optimizerResult = {"statistics":[],"allocations":[],"allocations_names":[],"allocations_categories":[]};
  optimizerResult = {
  statistics: [],
  allocations: [],
  allocations_names: [],
  allocations_categories: []
}
  previousAllocations = [];
  allocations = [];
  allocations_edit = [];
  regData = {"investmentAmount":1000000,"investment_ror":14,"maximum_allocation":100};
  totalAllocation = 0;
  allocationConstraintsStore = [];
  tempAllocationConstraintsStore = [];
  slider1_minValue: number = 1;
  slider1_maxValue: number = 100;
  slider_options: Options = {
    floor: this.slider1_minValue,
    ceil: this.slider1_maxValue
  };
  editStandardDeviation = false;
  minStandardDeviation = 0;
  maxStandardDeviation = 0;
  viewMode = 'tab1';
  previousMaxAllocations = 0;
  haveBeta:any;
  // current_need:string;
  // current_have:string;

  // CHAPVEST_APP_SERVICE_BASE_URL='http://localhost:3000/';
  CHAPVEST_APP_SERVICE_BASE_URL = 'https://node-backend.chapwood.apps.savantly.cloud/';
  CHAPTIMIZER_APP_SERVICE_BASE_URL = 'https://chapwood-optimizer.chapwood.apps.savantly.cloud/';

  constructor(private http: HttpClient,private slimLoadingBarService: SlimLoadingBarService,
    private toastr: ToastrService,private pageScrollService: PageScrollService, @Inject(DOCUMENT) private document: any,
    private router: Router,private route: ActivatedRoute,private dialog: MatDialog,
    public optimizerService: OptimizerServiceService){}

  ngOnInit(){

    this.startLoading();
    this.previousMaxAllocations = this.regData.maximum_allocation;
    this.initAllocationsArray();
    /** Check if QueryString parameters are passed. If yes load the solution based on parameters provided.*/
    var investment = this.route.snapshot.queryParamMap.get("investment");
    var ror = this.route.snapshot.queryParamMap.get("ror");
    var sd = this.route.snapshot.queryParamMap.get("sd");

    // this.current_need = this.route.snapshot.queryParamMap.get("need");
    // console.log(this.current_need);
    // this.current_have = this.route.snapshot.queryParamMap.get("have");
    // console.log(this.current_have);
    if(investment && investment.length>0 && ror && ror.length>0){
      this.regData.investmentAmount = Number(investment);
      this.regData.investment_ror = Number(Number(ror).toFixed(2));
      if(sd && sd.length>0){
        this.maxStandardDeviation = Number(sd);
      }
      this.fetchOptimalSolution(false);
    }else{
      /** Check if Local Storage has the data. If yes load the solution from Local Storage.*/
      if(localStorage.getItem("optimizerInputs") && localStorage.getItem("optimizerInputs")!=null && localStorage.getItem("optimizerInputs").length>0){
        this.retrieveSolution();
        this.postProcessDataHandler();
        this.loadAllocations();
      }
      this.completeLoading();
    }

    // If there is query params.. then show div element
    if (localStorage.getItem('Current_Need') == "null" && localStorage.getItem('Current_Have') == "null") {
      $(".HideShow").hide();
    }
    else {

      $(".HideShow").show();
      this.current_need_statistic_data();
      this.current_have_statistic_data();
      this.haveBeta=localStorage.getItem('beta_avg');
      // this.ProposedSolution();
    }

  }

  resetAll(){
    if(confirm("Are your sure you want to reset everything? Your current work will be lost.")){
     // this.optimizerResult = {"statistics":[],"allocations":[],"allocations_names":[],"allocations_categories":[]};

     this.optimizerResult = {
        statistics: [],
        allocations: [],
        allocations_names: [],
        allocations_categories: []
      }
      this.solution_rate_of_return=undefined;
      this.solution_standard_deviationsss =undefined;
      this.solution_variance_drag_phantom_tax = undefined;
      this.solution_sharpe_ratio = undefined;
      this.solution_probability_of_any_loss = undefined;
      this.solution_amount_of_money_at_risk = undefined;
      this.solution_upper_return = undefined;
      this.solution_lower_return = undefined;
      this.solution_beta=undefined;
      this.solution_upside_capture_ratio=undefined;
      this.solution_downside_capture_ratio=undefined;
      this.solution_ulcer_index=undefined;
      this.solution_amount_of_income=undefined;
      this.solution_income_percentage=undefined;



      this.previousAllocations = [];
      this.allocations = [];
      this.allocations_edit = [];
      this.totalAllocation = 0;
      this.allocationConstraintsStore = [];
      this.tempAllocationConstraintsStore = [];

      this.maxStandardDeviation=0;
      this.regData = {"investmentAmount":0,"investment_ror":0,"maximum_allocation":0};
    }
  }

  initAllocationsArray(){
    this.allocationConstraintsStore = [];
    // this.tempAllocationConstraintsStore = [];
    for(var i=0;i<this.allocations.length;i++){
      this.allocationConstraintsStore.push([0,0]);
      if(this.tempAllocationConstraintsStore.length !=142)
      {
      this.tempAllocationConstraintsStore.push([0,this.regData.maximum_allocation]);
      }
      this.allocations_edit.push(false);
    }

  }

  fetchOptimalSolution(addContraints:boolean){
    this.startLoading();
    var allocation_range_constraints:any;

    if(addContraints && addContraints==true){
      allocation_range_constraints = this.getAllocationsRangeConstraints();
    }else{
      allocation_range_constraints = []
      this.allocationConstraintsStore = [];
      this.tempAllocationConstraintsStore = [];
    }
    return this.http.post(
      this.optimizerService.getEndpointURL(),
      {
        "investment_amount":this.regData.investmentAmount,
        "mode":"maximize",
        "target_value":this.regData.investment_ror,
        "maximum_allocation":this.regData.maximum_allocation,
        "max_standard_deviation":this.maxStandardDeviation,
        "allocation_constraints": allocation_range_constraints,
        "uuid":localStorage.getItem('uuid')
      }).subscribe((data:any) => {

        this.optimizerResult = {
          statistics: [],
          allocations: [],
          allocations_names: [],
          allocations_categories: []
        }
        // this.ProposedSolution();
        this.setStatistics(data.statistics)
        this.previousAllocations = [];
        this.allocations = [];
        this.totalAllocation = 0;
        this.completeLoading();
        data = this.transformAllocations(data);
        this.optimizerResult = data;
        this.postProcessDataHandler();
        this.pageScrollService.scroll({
          document: this.document,
          scrollTarget: '.assetAllocations',
        });
      },(error:any) => {
        this.completeLoading();
        if(error.status == 500){
          this.toastr.error('Server ERROR! Please try again later!!');
        }else{
          this.toastr.error('Network ERROR!');
        }
      });
  }

  setStatistics(statistics){
    console.log(statistics)
    this.solution_rate_of_return = statistics.rate_of_return;
    this.solution_standard_deviationsss = statistics.standard_deviation;
    this.solution_variance_drag_phantom_tax = statistics.variance_drag_phantom_tax;
    this.solution_sharpe_ratio = statistics.sharpe_ratio;
    this.solution_probability_of_any_loss = statistics.probability_of_any_loss
    this.solution_amount_of_money_at_risk = statistics.amount_of_money_at_risk;
    this.solution_upper_return = statistics.upper_return;
    this.solution_lower_return = statistics.lower_return;
    this.solution_beta = statistics.beta;
    this.solution_downside_capture_ratio=statistics.downside_capture_ratio;
    this.solution_upside_capture_ratio=statistics.upside_capture_ratio;
    this.solution_ulcer_index=statistics.ulcer_index;
    this.solution_amount_of_income=statistics.amount_of_income;
    this.solution_income_percentage=statistics.percentage_of_income
  }



  postProcessDataHandler(){
    this.previousAllocations = this.copyArray(this.optimizerResult.allocations,this.previousAllocations);
    this.getTotalAllocation();
    //if(this.allocationConstraintsStore.length==0){
      this.initAllocationsArray();
    //}
    this.storeSolution();
}

  copyArray(source:Array<number>,dest:Array<number>){
    if(source && source.length>0){
      for(var i=0;i<source.length;i++){
        dest.push(source[i]);
      }
    }
    return dest;
  }

  handleSolutionData(data: string) {
    this.optimizerResult = JSON.parse(data);
  }

  roundDecimal(numb:number){
    if(numb){
      //return Math.round(numb);
      return numb.toFixed(2);
    }else{
      return 0;
    }
  }

  roundInteger(numb:number){
    if(numb){
      //return Math.round(numb);
      return numb.toFixed(0);
    }else{
      return 0;
    }
  }

  truncateDecimal(numb:any){
    if(numb){
      return Number(numb).toFixed(0);
    }else{
      return 0;
    }
  }

  calcAmount(numb:number){
    if(numb && this.regData.investmentAmount){
      return this.roundInteger(numb*this.regData.investmentAmount);
    }else{
      return 0;
    }
  }

  getActualReturns(numb:number){
    if(numb){
      return this.roundDecimal(numb);
    }else{
      return 0;
    }
  }

  getProbabilityPercent(numb:number){
    if(numb){
      return this.roundDecimal(numb*100);
    }else{
      return 0;
    }
  }

  getAnnualReturns(numb:number){
    if(numb){
      return this.roundDecimal(numb*12);
    }else{
      return 0;
    }
  }

  getMaxAllocation(){
    return this.roundInteger((this.regData.maximum_allocation/100)*this.regData.investmentAmount);
  }

  transformAllocations(response_data:any){
    var i=0;
    this.allocations = [];
    if(response_data.allocations){
      for(i=0;i<response_data.allocations.length;i++){
        this.allocations.push({"allocationVal":this.calcAmount(response_data.allocations[i])});
        response_data.allocations[i] = this.calcAmount(response_data.allocations[i]);
      }
    }
    // console.log("response_data.allocation",response_data)
    return response_data;
  }

  loadAllocations(){
    var i=0;
    this.allocations = [];
    if(this.optimizerResult && this.optimizerResult.allocations && this.optimizerResult.allocations.length>0){
      for(i=0;i<this.optimizerResult.allocations.length;i++){
        this.allocations.push({"allocationVal":this.optimizerResult.allocations[i]});
      }
    }
  }

  getTotalAllocation(){
    var i=0;
    var total = 0;
    for(i=0;i<this.optimizerResult.allocations.length;i++){
      total+=parseFloat(this.optimizerResult.allocations[i]);
    }
    this.totalAllocation = Math.round(total);
    return this.totalAllocation;
  }

  startLoading() {
      this.slimLoadingBarService.start(() => {
          console.log('Loading complete');
      });
  }

  stopLoading() {
      this.slimLoadingBarService.stop();
  }

  completeLoading() {
      this.slimLoadingBarService.complete();
  }

  allocationChanged(sidx:string,allocation:any,event:any){
    var val1:any;
    var val2:any;
    var idx:number = parseInt(sidx);
    if(this.previousAllocations.length>idx){
      val1 = this.previousAllocations[idx];
      val2 = allocation.allocationVal;
      console.log(val1+" , "+val2);
      if(val1!=val2){
        let allocationInputField = document.getElementsByClassName('allocations_input')[idx];
        if(allocationInputField){
          allocationInputField.classList.add("input-highlight");
        }
        return;
      }
    }
    let allocationInputField = document.getElementsByClassName('allocations_input')[idx];
    if(allocationInputField){
      allocationInputField.classList.remove("input-highlight");
    }
  }

  modelChanged(sidx:string,allocation:number,event:any){
    var val1:any;
    var val2:any;
    var idx:number = parseInt(sidx);
    if(this.optimizerResult.allocations.length>idx){
      this.optimizerResult.allocations[idx]=allocation;
    }
  }

  getAllocationsRangeConstraints(){
    var percent1:number;
    var percent2:number;
    // console.log('temp-allocation',this.tempAllocationConstraintsStore)
    for(var idx=0;idx<this.tempAllocationConstraintsStore.length;idx++){
      percent1 = this.tempAllocationConstraintsStore[idx][0]/100;
      percent2 = this.tempAllocationConstraintsStore[idx][1]/100;
      // console.log(percent1,percent2)
      this.allocationConstraintsStore[idx] = [percent1,percent2];
    }
    // console.log(this.allocationConstraintsStore)
    return this.allocationConstraintsStore;
  }

  getAllocationsConstraints(){
    var val1:any;
    var val2:any;
    var percent:number;
    for(var idx=0;idx<this.allocations.length;idx++){
      if(this.allocations.length>idx && this.previousAllocations.length>idx){
        val1 = this.previousAllocations[idx];
        val2 = this.allocations[idx].allocationVal;
        if(val1!=val2){
          percent = val2/this.regData.investmentAmount;
          this.allocationConstraintsStore[idx] = percent;
        }
      }
    }
    return this.allocationConstraintsStore;
  }

  sliderOnChange(){
    var percent1:number;
    var percent2:number;
    this.regData.maximum_allocation
    if(this.tempAllocationConstraintsStore && this.tempAllocationConstraintsStore.length>0){
      for(var idx=0;idx<this.tempAllocationConstraintsStore.length;idx++){
        if(this.tempAllocationConstraintsStore[idx] && this.tempAllocationConstraintsStore[idx].length>0){
          percent1 = this.tempAllocationConstraintsStore[idx][0];
          percent2 = this.tempAllocationConstraintsStore[idx][1];
          if(percent1 == 0 && percent2 == this.previousMaxAllocations){
            this.tempAllocationConstraintsStore[idx] = [0,this.regData.maximum_allocation]
          }
        }else{
          this.tempAllocationConstraintsStore[idx] = [0,this.regData.maximum_allocation]
        }
      }
    }
    this.previousMaxAllocations = this.regData.maximum_allocation;
  }

  storeSolution(){
    // store all required details

    let saved_statistics={
      "rate_of_return": this.solution_rate_of_return,
      "standard_deviationsss": this.solution_standard_deviationsss,
      "variance_drag_phantom_tax": this.solution_variance_drag_phantom_tax,
      "sharpe_ratio": this.solution_sharpe_ratio,
      "probability_of_any_loss": this.solution_probability_of_any_loss,
      "amount_of_money_at_risk": this.solution_amount_of_money_at_risk,
      "upper_return": this.solution_upper_return,
      "lower_return": this.solution_lower_return,
      "beta":this.solution_beta,
      "upside_capture_ratio":this.solution_upside_capture_ratio,
      "downside_capture_ratio":this.solution_downside_capture_ratio,
      "ulcer_index":this.solution_ulcer_index,
      "amount_of_income":this.solution_amount_of_income,
      "percentage_of_income":this.solution_income_percentage
    }

    localStorage.setItem("optimizerInputs",JSON.stringify(this.regData));
    localStorage.setItem("optimizerResult",JSON.stringify(this.optimizerResult));
    localStorage.setItem("maxStandardDeviation",""+this.maxStandardDeviation);
    localStorage.setItem("tempAllocationConstraintsStore",JSON.stringify(this.tempAllocationConstraintsStore));
    localStorage.setItem('saved_statistics',JSON.stringify(saved_statistics))
  }

  retrieveSolution(){
    // store all required details
    if(localStorage.getItem("optimizerInputs") && localStorage.getItem("optimizerInputs")!=null && localStorage.getItem("optimizerInputs").length>0){
      this.regData = JSON.parse(localStorage.getItem("optimizerInputs"));
    }
    if(localStorage.getItem("optimizerResult") && localStorage.getItem("optimizerResult")!=null && localStorage.getItem("optimizerResult").length>0){
      this.optimizerResult = JSON.parse(localStorage.getItem("optimizerResult"));
    }
    if(localStorage.getItem("maxStandardDeviation") && localStorage.getItem("maxStandardDeviation")!=null && localStorage.getItem("maxStandardDeviation").length>0){
      this.maxStandardDeviation = Number(localStorage.getItem("maxStandardDeviation"));
    }
    if(localStorage.getItem("tempAllocationConstraintsStore") && localStorage.getItem("tempAllocationConstraintsStore")!=null && localStorage.getItem("tempAllocationConstraintsStore").length>0){
      this.tempAllocationConstraintsStore = JSON.parse(localStorage.getItem("tempAllocationConstraintsStore"));
    }

    if(localStorage.getItem("saved_statistics") && localStorage.getItem("saved_statistics")!=null && localStorage.getItem("saved_statistics").length>0){
      let stats = JSON.parse(localStorage.getItem("saved_statistics"));
      this.solution_rate_of_return = stats.rate_of_return;
      this.solution_standard_deviationsss = stats.standard_deviationsss;
      this.solution_variance_drag_phantom_tax = stats.variance_drag_phantom_tax;
      this.solution_sharpe_ratio = stats.sharpe_ratio;
      this.solution_probability_of_any_loss = stats.probability_of_any_loss
      this.solution_amount_of_money_at_risk = stats.amount_of_money_at_risk;
      this.solution_upper_return = stats.upper_return;
      this.solution_lower_return = stats.lower_return;
      this.solution_beta=stats.beta;
      this.solution_upside_capture_ratio=stats.upside_capture_ratio;
      this.solution_downside_capture_ratio=stats.downside_capture_ratio;
      this.solution_ulcer_index=stats.ulcer_index;
      this.solution_amount_of_income=stats.amount_of_income;
      this.solution_income_percentage=stats.percentage_of_income
    }
  }

  printPortfolio(){
    this.storeSolution();
    this.router.navigate(['/print']);
  }



  current_have_statistic_data() {
    let url2 = this.CHAPVEST_APP_SERVICE_BASE_URL + 'statistics/' + localStorage.getItem('Current_Have');
    // alert('Have '+url2);
    this.http.get(url2).subscribe((res: Response) => {
      let userResponses2 = JSON.parse(JSON.stringify(res));
      console.log(userResponses2);
      this.rate_of_return = userResponses2.rate_of_return;
      this.standard_deviation = userResponses2.standard_deviation;
      this.variance_drag_phantom_tax = userResponses2.variance_drag_phantom_tax;
      this.sharpe_ratio = userResponses2.sharpe_ratio;
      this.probability_of_any_loss = userResponses2.probability_of_any_loss;
      this.amount_of_money_at_risk = userResponses2.amount_of_money_at_risk;
      this.upper_return = userResponses2.upper_return;
      this.lower_return = userResponses2.lower_return;
      this.beta= userResponses2.beta;
      this.upside_capture_ratio=userResponses2.upside_capture_ratio;
      this.downside_capture_ratio=userResponses2.downside_capture_ratio;
      this.solution_amount_of_income=userResponses2.amount_of_income;
      this.solution_income_percentage=userResponses2.percentage_of_income;
    })
  }

  current_need_statistic_data() {
    //let url3 = 'http://13.57.236.169:3000/statistics/' + localStorage.getItem('user_current_need_statistic');
    let url3 = this.CHAPVEST_APP_SERVICE_BASE_URL + 'statistics/' + localStorage.getItem('Current_Need');
    this.http.get(url3).subscribe((res: Response) => {
      let userResponses3 = JSON.parse(JSON.stringify(res));
      console.log(userResponses3);
      this.need_rate_of_return = userResponses3.rate_of_return;
      localStorage.setItem("rate of return", userResponses3.rate_of_return)
      this.need_standard_deviation = userResponses3.standard_deviation;
      localStorage.setItem("standard Deviation", userResponses3.standard_deviation)
      this.need_variance_drag_phantom_tax = userResponses3.variance_drag_phantom_tax;
      this.need_sharpe_ratio = userResponses3.sharpe_ratio;
      this.need_probability_of_any_loss = userResponses3.probability_of_any_loss;
      this.need_amount_of_money_at_risk = userResponses3.amount_of_money_at_risk;
      this.need_upper_return = userResponses3.upper_return;
      this.need_lower_return = userResponses3.lower_return;
      this.need_beta = userResponses3.beta;
    })
  }

  ProposedSolution() {
    let dialogRef: MatDialogRef<ProgressSpinnerComponent> = this.dialog.open(ProgressSpinnerComponent, {
      panelClass: 'transparent',
      disableClose: true,
    })
    let allocation_range_constraints = this.getAllocationsRangeConstraints()
    let url3 = this.CHAPTIMIZER_APP_SERVICE_BASE_URL + 'optimize';
    this.http.post(url3, {
      "allocation_constraints": allocation_range_constraints,
      "investment_amount": this.regData.investmentAmount,
      "max_standard_deviation": this.maxStandardDeviation,
      "maximum_allocation": 100,
      "mode": "maximize",
      "target_value": this.regData.investment_ror,
    }).subscribe((data: any) => {
      dialogRef.close()
      let userResponse4 = JSON.parse(JSON.stringify(data));
      // console.log(userResponse4);
      // console.log(userResponse4.statistics);
      this.solution_rate_of_return = userResponse4.statistics.rate_of_return;
      this.solution_standard_deviationsss = userResponse4.statistics.standard_deviation;
      this.solution_variance_drag_phantom_tax = userResponse4.statistics.variance_drag_phantom_tax;
      this.solution_sharpe_ratio = userResponse4.statistics.sharpe_ratio;
      this.solution_probability_of_any_loss = userResponse4.statistics.probability_of_any_loss
      this.solution_amount_of_money_at_risk = userResponse4.statistics.amount_of_money_at_risk;
      this.solution_upper_return = userResponse4.statistics.upper_return;
      this.solution_lower_return = userResponse4.statistics.lower_return;
      this.solution_beta=userResponse4.statistics.beta;
      this.solution_upside_capture_ratio=userResponse4.statistics.upside_capture_ratio;
      this.solution_downside_capture_ratio=userResponse4.statistics.downside_capture_ratio;
      this.solution_ulcer_index=userResponse4.statistics.ulcer_index;
      this.solution_amount_of_income=userResponse4.statistics.amount_of_income;
      this.solution_income_percentage=userResponse4.statistics.percentage_of_income;
    })
  }


}
